export const SIGN_IN="Sign in"
export const SIGN_OUT="Sign out"
export const WELCOME="Welcome"
export const JOIN="Join"